import React from 'react'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'

const PrivacySection = () => (
    <div>
        <Typography variant="h4" gutterBottom>
            Welcome to Mase Rasti Team Website
        </Typography>
        <Typography variant="h6" gutterBottom>
            Mase Rasti Real Estate Privacy Policy
        </Typography>
        <Typography variant="body1" gutterBottom>
            This Privacy Policy describes how your personal information is
            collected, used, and shared when you visit or use rasti.ca (the
            “Site”).
        </Typography>
        <Typography variant="h6" gutterBottom>
            PERSONAL INFORMATION WE COLLECT
        </Typography>
        <Typography variant="body1" gutterBottom>
            When you visit the Site, we automatically collect certain
            information about your device, including information about your web
            browser, IP address, time zone, and some of the cookies that are
            installed on your device. Additionally, as you browse the Site, we
            collect information about the individual web pages or products that
            you view, what websites or search terms referred you to the Site,
            and information about how you interact with the Site. We refer to
            this automatically-collected information as “Device Information.”
        </Typography>
        <Typography variant="body1" gutterBottom>
            We collect Device Information using the following technologies:
        </Typography>
        <ul>
            <li>
                - “Cookies” are data files that are placed on your device or
                computer and often include an anonymous unique identifier. For
                more information about cookies, and how to disable cookies,
                visit{' '}
                <Link href="https://www.allaboutcookies.org">
                    www.allaboutcookies.org
                </Link>
                .
            </li>
            <li>
                - “Log files” track actions occurring on the Site, and collect
                data including your IP address, browser type, Internet service
                provider, referring/exit pages, and date/time stamps.
            </li>
            <li>
                - “Web beacons,” “tags,” and “pixels” are electronic files used
                to record information about how you browse the Site.
            </li>
        </ul>
        <Typography variant="body1" gutterBottom>
            Additionally when you submit a form through the Site or open and
            account by registering on Site, we collect certain information from
            you, including your name, email address, and phone number and in
            some cases, your address. We refer to this information as “User
            Information.”
        </Typography>
        <Typography variant="body1" gutterBottom>
            When we talk about “Personal Information” in this Privacy Policy, we
            are talking both about Device Information and User Information.
        </Typography>
        <Typography variant="h6" gutterBottom>
            HOW DO WE USE YOUR PERSONAL INFORMATION?
        </Typography>
        <Typography variant="body1" gutterBottom>
            We use the User Information that we collect generally to fulfill any
            requests placed through the Site (including searching for properties
            for you). Additionally, we use this User Information to: Communicate
            with you; Screen our request for potential risk or fraud; and When
            in line with the preferences you have shared with us, provide you
            with information or advertising relating to our products or
            services. We use the Device Information that we collect to help us
            screen for potential risk and fraud (in particular, your IP
            address), and more generally to improve and optimize our Site (for
            example, by generating analytics about how our customers browse and
            interact with the Site, and to assess the success of our marketing
            and advertising campaigns).
        </Typography>
        <Typography variant="h6" gutterBottom>
            SHARING YOUR PERSONAL INFORMATION
        </Typography>
        <Typography variant="body1" gutterBottom>
            We share your Personal Information with third parties to help us use
            your Personal Information, as described above. We use Google
            Analytics to help us understand how our customers use the Site.
        </Typography>
        <Typography variant="body1" gutterBottom>
            You can read more about how Google uses your Personal Information
            here:{' '}
            <Link href="https://policies.google.com/privacy">
                policies.google.com/privacy
            </Link>
            .
        </Typography>
        <Typography variant="body1" gutterBottom>
            You can also opt-out of Google Analytics here:{' '}
            <Link href="https://tools.google.com/dlpage/gaoptout">
                tools.google.com/dlpage/gaoptout
            </Link>
            .
        </Typography>
        <Typography variant="body1" gutterBottom>
            Finally, we may also share your Personal Information to comply with
            applicable laws and regulations, to respond to a subpoena, search
            warrant or other lawful request for information we receive, or to
            otherwise protect our rights.
        </Typography>
        <Typography variant="h6" gutterBottom>
            DO NOT TRACK
        </Typography>
        <Typography variant="body1" gutterBottom>
            Please note that we do not alter our Site’s data collection and use
            practices when we see a Do Not Track signal from your browser.
        </Typography>
        <Typography variant="h6" gutterBottom>
            YOUR RIGHTS
        </Typography>
        <Typography variant="body1" gutterBottom>
            If you are a European resident, you have the right to access
            personal information we hold about you and to ask that your personal
            information be corrected, updated, or deleted. If you would like to
            exercise this right, please contact us through the contact
            information below.
        </Typography>
        <Typography variant="body1" gutterBottom>
            Additionally, if you are a European resident we note that we are
            processing your information in order to fulfill contracts we might
            have with you (for example if you make an evaluation or contact
            request through the Site), or otherwise to pursue our legitimate
            business interests listed above. Additionally, please note that your
            information will be transferred outside of Europe, including to
            Canada and the United States.
        </Typography>
        <Typography variant="h6" gutterBottom>
            DATA RETENTION
        </Typography>
        <Typography variant="body1" gutterBottom>
            When you place an request through the Site, we will maintain your
            User Information for our records unless and until you ask us to
            delete this information.
        </Typography>
        <Typography variant="h6" gutterBottom>
            CHANGES
        </Typography>
        <Typography variant="body1" gutterBottom>
            We may update this privacy policy from time to time in order to
            reflect, for example, changes to our practices or for other
            operational, legal or regulatory reasons.
        </Typography>
        <Typography variant="h6" gutterBottom>
            CONTACT US
        </Typography>
        <Typography variant="body1" gutterBottom>
            For more information about our privacy practices, if you have
            questions, or if you would like to make a complaint, please contact
            us by e-mail at{' '}
            <Link href="mailto:support@rastiteam.com">
                support [at] rastiteam [dot] com
            </Link>{' '}
            or by mail using the details provided below:
        </Typography>
        <Typography variant="body1" gutterBottom>
            3311 Yonge St, Toronto, ON, M4N 2L9, Canada
        </Typography>
    </div>
)

export default PrivacySection
